
import Grid3 from "../../../assets/filled/Grid3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Grid3Icon({ className, dataTestid = "Grid3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Grid3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
